exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'Helvetica Neue LT Std';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Helvetica Neue LT Std Regular'), url(" + require("./HelveticaNeueLTStd-Md.otf") + ") format('opentype');\n}\n@font-face {\n  font-family: 'Helvetica Neue LT Std';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Helvetica Neue LT Std Bold'), url(" + require("./HelveticaNeueLTStd-Bd.otf") + ") format('opentype');\n}\n@font-face {\n  font-family: 'Helvetica Neue LT Std';\n  font-style: italic;\n  font-weight: 400;\n  src: local('Helvetica Neue LT Std Regular Italic'), url(" + require("./HelveticaNeueLTStd-MdIt.otf") + ") format('opentype');\n}\n@font-face {\n  font-family: 'Helvetica Neue LT Std';\n  font-style: italic;\n  font-weight: 700;\n  src: local('Helvetica Neue LT Std Bold Italic'), url(" + require("./HelveticaNeueLTStd-BdIt.otf") + ") format('opentype');\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/~/css-loader!C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/HelveticaNeue/font.css
// module id = 339
// module chunks = 0